/**
 * English translations
 */
export default {
  "Sign in": "Sign in",
  "Your session has ended. Please sign in again.": "Your session has ended. Please sign in again.",
  "Sign-in was denied.": "Sign-in was denied.",
  "Sign-in expired. Please try again.": "Sign-in expired. Please try again.",
  "Sign-in failed. Please try later.": "Sign-in failed. Please try later.",
  "Unknown user": "Unknown user",
  "Unknown version": "Unknown version",
  "No sections are permitted.": "No sections are permitted.",
  "This section does not exist.": "This section does not exist.",
  "Go to the initial section": "Go to the initial section",

  "The installation license is invalid. Requests cannot be performed.": "The installation license is invalid. Requests cannot be performed.",
  'Session ended. Please log in again.': 'Session ended. Please log in again.',
  'Log in again': 'Log in again',
  "Change password": "Change password",
  "Current password": "Current password",
  "New password": "New password",
  "Password changed. Please log in again.": "Password changed. Please log in again.",
  "The submitted values were not accepted.": "The submitted values were not accepted.",
  "Authentication was not established. The operation was not performed.": "Authentication was not established. The operation was not performed.",
  "Authentication was not established.": "Authentication was not established.",
  "This operation is not permitted.": "This operation is not permitted.",
  "The requested object does not exist.": "The requested object does not exist.",
  "The operation conflicts with the current state.": "The operation conflicts with the current state.",
  "The server encountered an internal error.": "The server encountered an internal error.",
  "The server rejected the request without a reason.": "The server rejected the request without a reason.",
  "No response was received from the server.": "No response was received from the server.",
  'Unable to save event listener. Check the connection and retry.': 'Unable to save event listener. Check the connection and retry.',
  'Unable to save schedule. Check the connection and retry.': 'Unable to save schedule. Check the connection and retry.',
  'Unable to load job parameters (HTTP {status}). Reopen the form to retry.': 'Unable to load job parameters (HTTP {status}). Reopen the form to retry.',
  'Unable to load job parameters. Check the connection and reopen the form to retry.': 'Unable to load job parameters. Check the connection and reopen the form to retry.',
  'Date and time format': 'DD.MM.YYYY HH:mm:ss',
  'Unknown date and time': 'Unknown',
  'Enter date and time in the required format': 'Enter a valid date and time as DD.MM.YYYY HH:mm:ss',
  // Auth
  Username: 'Username',
  Password: 'Password',
  Login: 'Login',
  Logout: 'Logout',
  'Show password': 'Show password',
  'Please, fill in this field': 'Please, fill in this field',

  // Menu
  Resources: 'Resources',
  'Execution History': 'Execution History',
  Projects: 'Projects',
  Schedules: 'Schedules',
  'Events Listeners': 'Events Listeners',
  'Data Services': 'Data Services',
  Users: 'Users',
  Roles: 'Roles',

  // Resources
  'Resources utilization': 'Resources utilization',
  Worker: 'Worker',
  System: 'System',
  Performance: 'Performance',
  'Running jobs': 'Running jobs',
  CPU: 'CPU',
  RAM: 'RAM',
  Disk: 'Disk',
  Used: 'Used',
  Free: 'Free',
  of: 'of',
  gb: 'GB',
  Uptime: 'Uptime',
  Name: 'Name',
  IP: 'IP',
  'Current time': 'Current time',
  'UTC time': 'UTC time',
  Version: 'Version',
  Job: 'Job',

  // Common
  Loading: 'Loading',
  'Onebridge designer': 'Onebridge Designer',
  'Onebridge documentation': 'Onebridge Documentation',

  // Errors
  'Invalid credentials': 'Invalid credentials',
  'Authentication failed': 'Authentication failed',
  'Network error occurred': 'Network error occurred',
  'Username cannot be empty': 'Username cannot be empty',
  'Password cannot be empty': 'Password cannot be empty',

  // Schedules
  'New schedule': 'New schedule',
  'Create schedule': 'Create schedule',
  'Change schedule': 'Change schedule {name}',
  'Delete schedule': 'Delete schedule',
  'Edit schedule': 'Edit schedule',
  'Run linked graph': 'Run linked graph',
  'Name Schedule': 'Schedule Name',
  'The name cannot be empty': 'The name cannot be empty',
  'This name already exists': 'This name already exists',
  Periodicity: 'Periodicity',
  Once: 'Once',
  Interval: 'Interval',
  Timetable: 'Timetable',
  'Start time': 'Start time',
  'Run every': 'Run every',
  'Cron expression': 'Cron expression',
  'Invalid cron expression': 'Invalid cron expression',
  'Active from': 'Active from',
  'Active to': 'Active to',
  'Job file': 'Job file',
  'Please select a file': 'Please select a file',
  Project: 'Project',
  'Select project': 'Select project',
  'Select job file': 'Select job file',
  Params: 'Parameters',
  required: 'required',
  Create: 'Create',
  Save: 'Save',
  Close: 'Close',
  Delete: 'Delete',
  Cancel: 'Cancel',
  sec: 'sec',
  min: 'min',
  hr: 'hr',
  ID: 'ID',
  Enabled: 'Enabled',
  Schedule: 'Schedule',
  'Last run': 'Last run',
  'The status of the last run': 'The status of the last run',
  'Next run': 'Next run',
  Search: 'Search',
  Overview: 'Overview',
  Frequency: 'Frequency',
  'Last run number': 'Last run number',
  Created: 'Created',
  'Created by': 'Created by',
  Modified: 'Modified',
  'Modified by': 'Modified by',
  'Run graph': 'Run graph',
  'Input parameters': 'Input parameters',
  Showing: 'Showing',
  Previous: 'Previous',
  Next: 'Next',
  'per page': 'per page',
  pages: 'pages',
  rows: 'rows',
  Succeeded: 'Succeeded',
  Failed: 'Failed',
  Aborted: 'Aborted',
  InProgress: 'In Progress',
  Waiting: 'Waiting',
  Unknown: 'Unknown',
  'someHasBeenDelete.schedule': 'Are you sure you want to delete schedule "{name}"?',

  // Event Listeners
  'New listener': 'New listener',
  Listener: 'Listener',
  'Create listener': 'Create listener',
  'Change listener': 'Change listener {name}',
  'Delete event listener': 'Delete event listener',
  'Edit event listener': 'Edit event listener',
  'Name listener': 'Listener Name',
  Event: 'Event',
  'File event': 'File event',
  'Job finished event': 'Job finished event',
  'File system': 'File system',
  Path: 'Path',
  Check: 'Check',
  Action: 'Action',
  added: 'added',
  removed: 'removed',
  'Start job': 'Start job',
  'Run command': 'Run command',
  Started: 'Started',
  Program: 'Program',
  Arguments: 'Arguments',
  'comma separated': 'comma separated',
  'Interval must be greater than 0': 'Interval must be greater than 0',
  'This parameter is required': 'This parameter is required',
  'someHasBeenDelete.event': 'Are you sure you want to delete event listener "{name}"?',
  'events.file': 'File event',
  'events.job': 'Job finished event',
  'events.Finished': 'Finished job',
  'events.Status': 'Status',
  'events.Succeeded': 'Succeeded',
  'events.Failed': 'Failed',
  'events.Aborted': 'Aborted',
  'events.Any': 'Any',

  // Users
  'Add new user': 'Add new user',
  'Update user': 'Update user',
  'User created': 'User created',
  'Temporary password': 'Temporary password',
  Copy: 'Copy',
  Active: 'Active',
  'Full name': 'Full name',
  'Last login': 'Last login',
  Email: 'Email',
  Status: 'Status',
  'Edit user info': 'Edit user info',
  'Reset the password': 'Reset the password',
  'Аuthentication method': 'Аuthentication method',
  'Last login date': 'Last login date',
  'Last login status': 'Last login status',
  active: 'Active',
  inactive: 'Inactive',
  blocked: 'Blocked',
  'The login cannot be empty': 'The login cannot be empty',
  'The first name cannot be empty': 'The first name cannot be empty',
  'The email cannot be empty': 'The email cannot be empty',
  'All roles': 'All roles',
  'Assigned roles': 'Assigned roles',
  Privileges: 'Privileges',

  // Data Services
  'New data service': 'New data service',
  'Create data service': 'Create data service',
  'Change data service': 'Change data service {name}',
  'Delete data service': 'Delete data service',
  'Edit data service': 'Edit data service',
  'Data service': 'Data service',
  'Name data service': 'Data Service Name',
  Method: 'Method',
  Calls: 'Calls',
  Description: 'Description',
  Parameters: 'Parameters',
  'Job parameter': 'Job parameter',
  'URL name': 'URL name',
  Default: 'Default',
  Required: 'Required',
  Disabled: 'Disabled',
  'someHasBeenDelete.dataService': 'Are you sure you want to delete data service "{name}"?',

  // Projects
  'Create new project': 'Create new project',
  'Change project': 'Select a project or file',
  'Job Inspector': 'Job Inspector',
  'Content': 'Content',
  Type: 'Type',
  Size: 'Size',
  project: 'project',
  directory: 'directory',
  file: 'file',
  'Edit file': 'Edit file',
  'Rename project': 'Rename project',
  'Rename directory': 'Rename directory',
  'Rename file': 'Rename file',
  'Create directory': 'Create directory',
  'Create file': 'Create file',
  'Upload files': 'Upload files',
  'Download as an archive': 'Download as an archive',
  'Download file': 'Download file',
  'Create schedule in projects': 'Create schedule',
  'Delete project': 'Delete project',
  'Delete directory': 'Delete directory',
  'Delete file': 'Delete file',
  'New name': 'New name',
  Template: 'Template',
  in: 'in',
  'project name': 'Project name',
  'directory name': 'Directory name',
  'file name': 'File name',
  'Create project header modal': 'Create project',
  'Create directory header modal': 'Create directory',
  'Create file header modal': 'Create file',
  'The file size is too large to display its content': 'The file size is too large to display its content',
  'Oops, something wrong with the file': 'Oops, something wrong with the file',
  'runModalHeader': 'Run',
  'Run with the following input parameters. Other parameters have default values': 'Run with the following input parameters. Other parameters have default values',
  'input parameters': 'Input parameters',
  'No parameters required': 'No parameters required',
  'Loading...': 'Loading...',
  'someHasBeenDelete.project': 'Are you sure you want to delete project "{name}"?',
  'someHasBeenDelete.directory': 'Are you sure you want to delete directory "{name}"?',
  'someHasBeenDelete.file': 'Are you sure you want to delete file "{name}"?',

  // Execution History
  Filter: 'Filter',
  Reset: 'Reset',
  'Date from': 'Date from',
  'Date to': 'Date to',
  'Run ID': 'Run ID',
  'Run number': 'Run number',
  'Job name': 'Job',
  User: 'User',
  Submitted: 'Submitted',
  'Content file': 'Content file',
  Run: 'Run',
  Rerun: 'Rerun',
  Stop: 'Stop',
  'Download log': 'Download log',
  Tracking: 'Tracking',
  'Log File': 'Log File',
  Duration: 'Duration',
  'Launch type': 'Launch type',
  Finished: 'Finished',
  Phase: 'Phase',
  COMPONENT: 'COMPONENT',
  STATUS: 'STATUS',
  DURATION: 'DURATION',
  PORT: 'PORT',
  RECORDS: 'RECORDS',
  'RECS/S': 'RECS/S',
  'RECS/S MAX': 'RECS/S MAX',
  'RECS/S AVG': 'RECS/S AVG',
  INPUT: 'INPUT',
  OUTPUT: 'OUTPUT',
  'No data': 'No data',
  'All statuses': 'All statuses',

  // Roles
  'Add new role': 'Add new role',
  'Update role': 'Update role',
  'Delete role': 'Delete role',
  'Edit role': 'Edit role',
  'Failed to create role': 'Failed to create role',
  'Failed to update role': 'Failed to update role',
  'someHasBeenDelete.role': 'Are you sure you want to delete role "{name}"?',
}
